import {
  createSystem,
  defaultConfig,
  defineConfig,
  // defineAnimationStyles,
} from "@chakra-ui/react";

// const animationStyles = defineAnimationStyles({
//   bounceFadeIn: {
//     value: {
//       animationName: "bounce, fade-in",
//       animationDuration: "1s",
//       animationTimingFunction: "ease-in-out",
//       animationIterationCount: "infinite",
//     },
//   },
// });

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: "#1d1a4f" },
          100: { value: "#1d1a4f" },
          200: { value: "#1d1a4f" },
          300: { value: "#1d1a4f" },
          400: { value: "#1d1a4f" },
          500: { value: "#1d1a4f" },
          950: { value: "#1d1a4f" },
        },
        primary: { value: "#1d1a4f" },
        secondary: { value: "green" },
        white: { value: "#ffffff" },
        fontdark: { value: "#4c4c4c" },
        link: { value: "#003c8d" },
        buttonblue: { value: "#0d88d5" },
        darkbg: { value: "rgb(9, 8, 28)" },
        green2: { value: "rgba(11, 134, 22, 1)" },
        green2lite: { value: "rgba(11, 255, 22, 1)" },
        red3: { value: "rgba(134, 11, 11, 1)" },
        red3lite: { value: "rgba(255, 11, 11, 1)" },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: "{colors.brand.500}" },
          contrast: { value: "{colors.brand.100}" },
          fg: { value: "{colors.brand.700}" },
          muted: { value: "{colors.brand.100}" },
          subtle: { value: "{colors.brand.200}" },
          emphasized: { value: "{colors.brand.300}" },
          focusRing: { value: "{colors.brand.500}" },
        },
        text: {
          value: { base: "{colors.primary}", _dark: "{colors.white}" },
        },
        textlite: {
          value: { base: "{colors.white}" },
        },
        textgray: {
          value: { base: "{colors.fontdark}", _dark: "{colors.white}" },
        },
        textv2: {
          base: {
            value: { base: "{colors.fontdark}", _dark: "{colors.white}" },
          },
          brand: {
            value: { base: "{colors.primary}", _dark: "{colors.white}" },
          },
          lite: {
            value: { base: "{colors.white}", _dark: "{colors.primary}" },
          },
          green2: {
            value: { base: "{colors.green2}", _dark: "{colors.green2lite}" },
          },
          dang: {
            value: { base: "{colors.red3}", _dark: "{colors.red3lite}" },
          },
        },
        button: {
          solid: {
            value: { base: "{colors.buttonblue}" },
          },
          solid2: {
            value: { base: "{colors.primary}", _dark: "{colors.white}" },
          },
          outline: {
            value: { base: "{colors.white}", _dark: "{colors.primary}" },
          },
        },
        card: {
          darkgray: {
            value: { base: "{colors.fontdark}", _dark: "{colors.white}" },
          },
          tooltip: {
            value: { base: "{colors.primary}", _dark: "{colors.white}" },
          },
        },
        spinner: {
          value: { base: "{colors.primary}", _dark: "{colors.white}" },
        },
        shadow: {
          value: { base: "white", _dark: "fontdark" },
        },
        tablehead: {
          outline: {
            value: { base: "colors.white", _dark: "{colors.primary}" },
          },
          solid: {
            value: { base: "colors.primary", _dark: "{colors.primary}" },
          },
        },
        table: {
          activeitem: {
            value: {
              base: "colors.buttonblue",
              _dark: "{colors.buttonblue}",
            },
          },
          bg: {
            value: {
              base: "{colors.white}",
              _dark: "#000",
            },
          },
        },
        appbg: {
          solid: {
            value: { base: "colors.white", _dark: "{colors.darkbg}" },
          },
        },
        home: {
          card: {
            value: { base: "colors.white", _dark: "{colors.darkbg}" },
          },
        },
      },
    },
    // animationStyles,
  },
});

const system = createSystem(defaultConfig, config);

export { system };
